import React from 'react'
import { Navigate, Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'

// evertel
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'

/**
 * Layout wrapper for unauthorized (public) routes.
 * Mirrors mobile's UnAuthorizedLayout for parity.
 *
 * If a logged-in user navigates to a public route,
 * redirect them to landing instead.
 */
const UnAuthorizedLayout: React.FC = observer(() => {
    const sessionService = useService(SessionService, [])

    if (sessionService.currentUserId) {
        return <Navigate to="/landing" replace />
    }

    return <Outlet />
})

export default UnAuthorizedLayout
